import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Table, Tooltip, Card, Divider, Row, Col, Empty } from 'antd';
import { createUseStyles } from 'react-jss'

import {
    PlusCircleOutlined,
    MinusCircleOutlined,
    ExclamationCircleOutlined,
    CloseCircleOutlined
} from '@ant-design/icons';



import { Action, POST, QueryDetail, QueryOrder, QueryParam, READWITH, errorCatch, updateInArray } from 'fennec-ui'
import Rule from '../../../common/Rule'

import { DropdownAction } from 'fennec-ui'

import ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii from '../../forms/ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii'
import ZakritieZasedaniyaPravleniyaFederatsii from '../../forms/ZakritieZasedaniyaPravleniyaFederatsii'

import REDUX_ZasedaniyaPravleniyaFederatsii from '../../../objects/ZasedaniyaPravleniyaFederatsii/reducer';
import CRUDE_ZasedaniyaPravleniyaFederatsii from '../../../objects/ZasedaniyaPravleniyaFederatsii/crude';

import REDUX_ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii from '../../../objects/ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii/reducer';
import CRUDE_ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii from '../../../objects/ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii/crude';

import REDUX_VPDZasedaniyaPravleniyaFederatsii from '../../../objects/VPDZasedaniyaPravleniyaFederatsii/reducer';

import REDUX_DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii from '../../../objects/DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii/reducer'
import PageLayout from '../../components/PageLayout';

const useStyles = createUseStyles({
    modal: {
        '& .ant-modal-title': {
            marginRight: "25px"
        }
    },
    divider: {
        '&.ant-divider-horizontal.ant-divider-with-text-left': {
            fontFamily: "-apple-system, BlinkMacSystemFont, Roboto, 'Open Sans', 'Helvetica Neue', 'Noto Sans Armenian', 'Noto Sans Bengali', 'Noto Sans Cherokee', 'Noto Sans Devanagari', 'Noto Sans Ethiopic', 'Noto Sans Georgian', 'Noto Sans Hebrew', 'Noto Sans Kannada', 'Noto Sans Khmer', 'Noto Sans Lao', 'Noto Sans Osmanya', 'Noto Sans Tamil', 'Noto Sans Telugu', 'Noto Sans Thai', sans-serif",
            fontSize: "13px",
            fontWeight: "400",
            color: "rgb(0, 0, 0)",
        },
        '&.ant-divider-horizontal.ant-divider-with-text-left .ant-divider-inner-text': {
            padding: "0px",
            marginRight: "10px",
        }
    },
    block: {
        '& .buttons': {
            marginBottom: "10px"
        },
        // '& .buttons .ant-btn': {
        //     border: "none",
        //     '-webkit-box-shadow': "none",
        //     'box-shadow': "none"
        // }
    },
    actionTitle: {
        marginBottom: "5px"
    }
})

function Btn(props) {
    const { auth, setVoprosi } = props;
    const dispatch = useDispatch();
    const update = (values, unlock, close) => {
        var missing = props.object.zasedaniePravleniyaFederatsii.kolichestvoPrisutstvuyushchikhChlenovPravleniya - (values.za + values.protiv + values.vozderzhalsya + values.neProgolosoval);
        var v = {
            ...values,
            neProgolosoval: values.neProgolosoval + missing
        }
        POST(auth, `/api/query-update/ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii`, { ...props.object, ...v }, ({ data }) => {
            if (close) close();
            setVoprosi(o => updateInArray(o, data))
        }, errorCatch)
        // CRUDE_ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii.update(props.auth, (data) => {
        //     if (close) close();
        //     dispatch(REDUX_ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii.actions.updateArray([data]));
        // }, { ...props.object, ...v }, dispatch);
    };
    return (
        <DropdownAction items={[
            {
                ...props,
                modal: { width: "700px" },
                action: update,
                mode: "MenuItem",
                auth: props.auth,
                callback: props.callback,
                object: props.object,
                title: "Решение по вопросу",
                form: ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii,
                document: "resheniepovoprosupovestkidnyazasedaniyapravleniyafederatsii",
            }
        ]} />
    )
};
export default function FederationadministratorFederalgovernmentVotingcurrentmeeting(props) {
    const classes = useStyles();
    const { auth } = props;
    // const [zasedaniya, setZasedaniya] = useState(undefined);
    // const [voprosi, setVoprosi] = useState([]);

    const dispatch = useDispatch();
    // const zasedaniya = useSelector(REDUX_ZasedaniyaPravleniyaFederatsii.selector.object);
    // const voprosi = useSelector(REDUX_ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii.selector.array);
    const [zasedanie, setZasedanie] = useState();
    const [voprosi, setVoprosi] = useState();

    // var available = true;
    // useEffect(
    //     () => {
    //         available = true;
    //         return () => {
    //             available = false;
    //         };
    //     },
    //     [ /* TODO: memoization parameters here */]
    // );
    const requestVoprosi = (zasedanie) => {
        if (zasedanie) {
            READWITH(auth, "ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii", [
                QueryDetail("model"),
                QueryParam("w-ZasedaniePravleniyaFederatsii.ID", zasedanie?.ID),
                QueryOrder("voprosPovestkiDnyaZasedaniyaPravleniyaFederatsii.nomerVoprosa", "ASC")
            ], ({ data }) => {
                setVoprosi(data);
            }, errorCatch)
        }

        // CRUDE_ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii.read(auth, (data) => {
        //     if (available && data.length > 0) {
        //         dispatch(REDUX_ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii.actions.setArray(data.sort((a, b) => {
        //             if (a.ID < b.ID) {
        //                 return -1;
        //             }
        //             if (a.ID > b.ID) {
        //                 return 1;
        //             }
        //             return 0;
        //         })));
        //     }
        // }, 'model', 's-voprosPovestkiDnyaZasedaniyaPravleniyaFederatsii.nomerVoprosa&w-ZasedaniePravleniyaFederatsii.ID=' + zasedanie.ID);

        // auth.fetch('/api/query/VoprosiPovestkiDnyaZasedaniyaPravleniyaFederatsii?detail=model&s-nomerVoprosa&w-ZasedaniePravleniyaFederatsii.ID=' + zasedanie.ID).then(r => {
        //     if (available && r && r.data && r.data.length > 0) {
        //         setVoprosi(r.data);
        //     }
        // });
    };
    // useEffect(() => {
    //     CRUDE_ZasedaniyaPravleniyaFederatsii.read(auth, (data) => {
    //         if (available && data.length > 0) {
    //             dispatch(REDUX_ZasedaniyaPravleniyaFederatsii.actions.setObject(data[0]));
    //             requestVoprosi(data[0]);
    //         }
    //     }, 'model', 'w-nu-DataOkonchaniyaZasedaniya');
    // }, []);
    useEffect(() => {
        READWITH(auth, "ZasedaniyaPravleniyaFederatsii", [
            QueryDetail("model"),
            QueryParam("w-nu-DataOkonchaniyaZasedaniya"),
            QueryParam("w-in-tekushchiiStatusZasedaniya.ID", "3,4")
        ], ({ data }) => {
            if (data?.length) {
                setZasedanie(data[0]);
            }
        }, errorCatch)
    }, []);

    useEffect(() => {
        if (zasedanie) {
            requestVoprosi(zasedanie);
        }
    }, [zasedanie]);
    const columns = [
        {
            title: '№',
            render: (text, record) => {
                return (record.voprosPovestkiDnyaZasedaniyaPravleniyaFederatsii.nomerVoprosa);
            }
        },
        {
            title: 'Вопрос',
            render: (text, record) => {
                return (record.voprosPovestkiDnya);
            }
        },
        {
            title: 'Решение',
            render: (text, record) => {
                return (record.resheniePoVoprosuPovestkiDnya);
            }
        },
        {
            title: <Tooltip title="За"><PlusCircleOutlined style={{ color: "green" }} /></Tooltip>,
            render: (text, record) => {
                return (record.za);
            }
        },
        {
            title: <Tooltip title="Против"><MinusCircleOutlined style={{ color: "red" }} /></Tooltip>,
            render: (text, record) => {
                return (record.protiv);
            }
        },
        {
            title: <Tooltip title="Воздержался"><ExclamationCircleOutlined style={{ color: "orange" }} /></Tooltip>,
            render: (text, record) => {
                return (record.vozderzhalsya);
            }
        },
        {
            title: <Tooltip title="Не проголосовал"><CloseCircleOutlined style={{ color: "grey" }} /></Tooltip>,
            render: (text, record) => {
                return (record.neProgolosoval);
            }
        },
        // {
        //     title: 'Принято',
        //     render: (text, record, index) => {
        //         return (record.prinyatoReshenie);
        //     }
        // },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record) => (<Btn auth={auth} object={record} callback={() => {
                requestVoprosi(zasedanie);
            }} />),
        },
    ];
    const closeCallback = (res) => {
        // const { history } = props;
        setZasedanie(res.data.zasedanieRegionalnogoPravleniya);
        setVoprosi([]);

        // if (available) {
        //     dispatch(REDUX_ZasedaniyaPravleniyaFederatsii.actions.setObject(undefined));
        //     dispatch(REDUX_VPDZasedaniyaPravleniyaFederatsii.actions.setArray([]));
        //     dispatch(REDUX_DokumentPrisutstvuyushchieNaZasedaniiPravleniyaFederatsii.actions.setArray([]));
        //     dispatch(REDUX_ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii.actions.setArray([]));
        //     // history.push("/app/federation-administrator/federal-government/general");
        //     dispatch({ type: "PATH", payload: "/app/federation-administrator/federal-government/general" });
        // }
    };
    return (
        <PageLayout>
            <div style={{ backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ padding: "10px" }}>
                    <div>
                        <Divider className={classes.divider} type="horizontal" orientation="left">
                            Голосование на текущем заседании правления федерации
                        </Divider>

                        <Table columns={columns} dataSource={voprosi} style={{ paddingBottom: "15px" }} locale={{ emptyText: <Empty description={"Нет вопросов повестки дня для голосования"}></Empty> }} size="small" rowKey={(r) => r.ID} />

                        {/* <Rule type={"resheniepovoprosupovestkidnyazasedaniyapravleniyafederatsii"}
                                  object={zasedanie}>
                                <Action {...props} object={zasedanie} title={"Решение по вопросу повестки дня заседания правления федерации"} form={ResheniePoVoprosuPovestkiDnyaZasedaniyaPravleniyaFederatsii} document={"resheniepovoprosupovestkidnyazasedaniyapravleniyafederatsii"} />
                            </Rule> */}

                        <Rule type={"zakritiezasedaniyapravleniyafederatsii"} object={zasedanie}>
                            <Action {...props}
                                // callback={closeCallback}
                                object={zasedanie}
                                title={"Закрытие заседания правления федерации"}
                                form={ZakritieZasedaniyaPravleniyaFederatsii}
                                // document={"zakritiezasedaniyapravleniyafederatsii"}
                                action={(values, unlock, close) => {
                                    POST(auth, `/api/zakritiezasedaniyapravleniyafederatsii`, values,
                                        (res) => {
                                            closeCallback(res)
                                            close()
                                        }, (err) => errorCatch(err, unlock)
                                    )
                                }}
                            />
                        </Rule>
                    </div>
                </div>
            </div>
        </PageLayout>
    );
}
